import axios from 'axios';
import customAxios from '@/utils/custom-axios';

const patientAccountApi = `${process.env.VUE_APP_API}/medicine/account`;

export const MedicineService = {
  getOrders: () => {
    return customAxios.get(
      `${patientAccountApi}/orders`,
    );
  },
  getOrder: (orderid) => customAxios.get(`${patientAccountApi}/orders/${orderid}`),
  getPartners: () => customAxios.get(`${process.env.VUE_APP_API}/partners`),
  getOrderFile(orderid, uploadid) {
    return customAxios.get(`${patientAccountApi}/orders/${orderid}/files/${uploadid}`);
  },
  cancelOrder: (orderid, body) => customAxios.post(`${patientAccountApi}/cancel/${orderid}`, body),
  reportOrder: (orderid, remarks) => customAxios.post(
    `${patientAccountApi}/reportorder/${orderid}`,
    {remarks},
  ),
  getWatsonsCities() {
    return axios.get(`${process.env.VUE_APP_API}/partners/watsons/cities`);
  },
  getWatsonsBranch(cityname = '') {
    return axios.get(`${process.env.VUE_APP_API}/partners/watsons/branches`, {
      params: {
        coverage: cityname,
      },
    });
  },
  submitOrder(body) {
    return customAxios.post(
      `${patientAccountApi}/orders`,
      body,
    );
  },
  submitCoupon(body) {
    return customAxios.post(
      `${process.env.VUE_APP_API}/coupons`,
      body,
    );
  },
  suggestService(body) {
    return customAxios.post(
      `${process.env.VUE_APP_API}/medicine/suggest`,
      body,
    )
  }
};
